import get from 'lodash.get';

import { selectEmailConfirmation } from '../../../../redux/auth/emailConfirmation/selectors';
import { selectModal } from '../../../../redux/router/selectors';
import { email } from '../../../../attrs/content';

import { createDeepEqualSelector } from '../../../../redux/utils/selectors';

import { MODAL_EMAIL_CONFIRMATION } from '../../../../constants/app';

export const selectActivated = createDeepEqualSelector(selectEmailConfirmation, (emailConfirmation) =>
  get(emailConfirmation, 'success', false),
);

export const selectError = createDeepEqualSelector(selectEmailConfirmation, (emailConfirmation) =>
  get(emailConfirmation, 'err', false),
);

export const selectErrorMessage = createDeepEqualSelector(selectEmailConfirmation, (emailConfirmation) => {
  const error = get(emailConfirmation, 'errMsg', 'Error');

  return `Account could not be activated. Please get in touch with us at ${email}. ${error}`;
});

export const selectIsLoading = createDeepEqualSelector(selectEmailConfirmation, (emailConfirmation) =>
  get(emailConfirmation, 'loading', false),
);

export const selectIsVisible = createDeepEqualSelector(selectModal, (modal) => modal === MODAL_EMAIL_CONFIRMATION);
